import React, { useEffect, useState } from "react";
import {
  Container,
  Image,
  Nav,
  Navbar,
  NavDropdown,
  Button,
} from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import logo_signin from "../assets/images/logo_signin.png";
import { useDispatch, useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import HomeIcon from "@mui/icons-material/Home";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  apiHeader,
  firebaseVapidObject,
  URL as BaseURL,
} from "../Config/apiUrl";
import { Post, Get } from "../Axios/AxiosFunctions";
import { signOutRequest } from "../store/Actions/authAction";
import { useHistory } from "react-router-dom";
import { imageUrl } from "./../Config/apiUrl";
import { RiArrowDropDownLine } from "react-icons/ri";
import { VscLock } from "react-icons/vsc";
import { MdOutlineAddTask } from "react-icons/md";
import { BsBell } from "react-icons/bs";
import NotificationMenu from "./NotificationMenu";
import firebase, { messaging } from "../firebase";

const Header = () => {
  const [myFCMToken, setMyFCMToken] = useState("");

  // If firebase supported, take out token and send to server
  useEffect(() => {
    const getToken = async () => {
      let token = "";
      if (firebase.messaging.isSupported()) {
        token = await messaging.getToken(firebaseVapidObject);
        setMyFCMToken(token);
      }
    };

    getToken();
  }, []);

  const history = useHistory();
  const role = useSelector((state) => state?.authReducer?.user?.UserId?.role);
  const userData = useSelector((state) => state?.authReducer?.user);
  const token = useSelector((state) => state?.authReducer?.access_token);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openNotifications, setOpenNotifications] = useState(null);
  const [isNotificationWindowOpen, setIsNotificationWindowOpen] =
    useState(false);
  const [notiEvent, setNotiEvent] = useState(null);
  const openNot = Boolean(openNotifications);
  const handleOpenNotifications = (event) => {
    setIsNotificationWindowOpen((p) => !p);
    // setOpenNotifications(event.currentTarget);
    setNotiEvent(event.currentTarget);

    if (newNotifications !== 0 && token) {
      Get(BaseURL("notifications/seen-all-notfs"), token, false).then(
        (res) => console.log("all read")
      );
    }
  };
  useEffect(() => {
    if (isNotificationWindowOpen) {
      setOpenNotifications(notiEvent);
    } else {
      setOpenNotifications(null);
    }
  }, [isNotificationWindowOpen]);
  const [notifications, setNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState(0);

  const dispatch = useDispatch();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // handle Logout
  const handleLogout = async () => {
    const url = BaseURL(`general/logout`);
    const data = {
      fcmToken: myFCMToken,
    };
    const response = await Post(url, data, apiHeader(token));
    if (response !== undefined) {
      dispatch(signOutRequest());
      history.replace("/");
    }
  };
  // console.log(userData);

  async function getNotifications() {
    const url = BaseURL("notifications/all");
    const response = await Get(url, token);
    if (response !== undefined) {
      // console.log(response);
      setNotifications(response?.data?.data);
      setNewNotifications(response?.data?.newNotifications);
    }
  }

  useEffect(() => {
    token && getNotifications();
  }, [token, window.location.pathname]);

  return (
    <div className="header_shadow">
      <Navbar expand="lg" className="nav_div small_container ">
        <Container>
          <Navbar.Brand href="/">
            <Image className="img-fluid" src={logo_signin} />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{ backgroundImage: "unset" }}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="m-auto navbar_main">
              <NavLink exact to="/">
                Home{" "}
              </NavLink>
              <NavLink exact to="/Companies">
                Companies{" "}
              </NavLink>

              <NavLink to="/Craftmen">Craftsmen </NavLink>
              <NavLink to="/AllJobs">
                {role == "company" ? "All Craftmans" : "All Jobs"}
              </NavLink>
              <NavLink to="/aboutus">About </NavLink>
              <NavLink to="/contactus">Contact </NavLink>
              {token && (
                <NavLink
                  to="#"
                  className="bell-icon-link"
                  onClick={handleOpenNotifications}
                  id="basic-button"
                  aria-controls={openNot ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openNot ? "true" : undefined}
                >
                  <BsBell size={20} className="icon" />
                  {newNotifications != 0 && (
                    <div className="badge-x">{newNotifications}</div>
                  )}
                  <NotificationMenu
                    openNot={openNot}
                    notifications={notifications}
                    openNotifications={openNotifications}
                    setOpenNotifications={setOpenNotifications}
                    setAnchorEl={setAnchorEl}
                  />
                </NavLink>
              )}
              {token ? (
                // <button
                //   id="fade-button"
                //   aria-controls="fade-menu"
                //   aria-haspopup="true"
                //   aria-expanded={open ? "true" : undefined}
                //   onClick={handleClick}
                // >

                //   {userData.userName}
                // </button>
                <div className="avtar-box" onClick={handleClick}>
                  <Avatar
                    src={`${imageUrl}${userData?.photo}`}
                    className="headerAvtar"
                  />
                  <span>
                    {userData?.UserId?.role === "user"
                      ? userData?.userName
                      : userData?.companyName}
                    <RiArrowDropDownLine style={{ fontSize: "30px" }} />
                  </span>
                </div>
              ) : (
                <>
                  <NavLink to="/signin" className="black">
                    Sign In{" "}
                  </NavLink>
                  <NavLink to="/signup">
                    <Button className="header_btn">Sign Up</Button>{" "}
                  </NavLink>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Menu
        className="userMenu_B"
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleClose}>
          <div
            className="d-flex w-100"
            onClick={() =>
              role == "company"
                ? history.push("/dashboard")
                : history.push("/profile")
            }
          >
            <HomeIcon />
            <p>Dashboard</p>
          </div>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <div
            className="d-flex w-100"
            onClick={() => {
              role == "company"
                ? history.push("/editProfile")
                : history.push("/editProfile");
            }}
          >
            <PermIdentityIcon />
            <p>Profile</p>
          </div>
        </MenuItem>
        {/* Messagwes */}
        <MenuItem onClick={handleClose}>
          <div
            className="d-flex w-100"
            onClick={() => history.push("/messages")}
          >
            <MailOutlineIcon />
            <p>Messages</p>
          </div>
        </MenuItem>
        {/* changePassword */}
        <MenuItem onClick={handleClose}>
          <div
            className="d-flex w-100"
            onClick={() => history.push("/changePassword")}
          >
            <VscLock style={{ fontSize: "25px" }} />
            <p>Change Password</p>
          </div>
        </MenuItem>
        {/* appl;ied jobs */}
        {role !== "company" && (
          <MenuItem onClick={handleClose}>
            <div
              className="d-flex w-100"
              onClick={() => {
                history.push("/appliedJobs");
              }}
            >
              <MdOutlineAddTask style={{ fontSize: "25px" }} />
              <p>Applied Jobs</p>
            </div>
          </MenuItem>
        )}
        <MenuItem onClick={handleClose}>
          <div
            className="d-flex w-100"
            onClick={() => {
              role == "company"
                ? history.push("/company-contracts")
                : history.push("/my-contracts");
            }}
          >
            <WorkOutlineIcon />
            <p className="">My Contracts</p>
          </div>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <div className="d-flex w-100" onClick={handleLogout}>
            <LogoutIcon />
            <p>Logout</p>
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default Header;
